var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "div",
        {
          on: {
            click: function ($event) {
              return _vm.openPopupCharged()
            },
          },
        },
        [
          _vm.cellValue
            ? _c(
                "vs-button",
                { attrs: { size: "small", color: "success", type: "border" } },
                [_vm._v("Cobrado")]
              )
            : _c(
                "vs-button",
                { attrs: { size: "small", color: "danger", type: "border" } },
                [_vm._v("No cobrado")]
              ),
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: _vm.title, active: _vm.popupActive },
          on: {
            "update:active": function ($event) {
              _vm.popupActive = $event
            },
          },
        },
        [
          _c("p", [
            _vm._v(" Marcar como\n        "),
            _vm.cellValue
              ? _c("span", { staticClass: "text-dark uppercase" }, [
                  _vm._v("no cobrado"),
                ])
              : _c("span", { staticClass: "text-dark uppercase" }, [
                  _vm._v("cobrado"),
                ]),
          ]),
          _c(
            "vs-button",
            {
              staticClass: "float-right",
              attrs: { color: "primary", type: "filled" },
              on: {
                click: function ($event) {
                  return _vm.changeStateCharged()
                },
              },
            },
            [_vm._v("Cambiar")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }